"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useForm = function useForm(_ref) {
  var initialState = _ref.initialState,
      _onSubmit = _ref.onSubmit,
      _onChange = _ref.onChange;

  var _useState = (0, _react.useState)(initialState),
      formState = _useState[0],
      setFormState = _useState[1];

  var _useState2 = (0, _react.useState)({}),
      validationMessages = _useState2[0],
      setValidationMessages = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isSubmitting = _useState3[0],
      setIsSubmitting = _useState3[1];

  return {
    setValidationMessages: setValidationMessages,
    validationMessages: validationMessages,
    formState: formState,
    setFormState: setFormState,
    onSubmit: function onSubmit(event) {
      if (event) event.preventDefault();

      _onSubmit();
    },
    onChange: function onChange(event) {
      var target = event.currentTarget;
      var value = target.type === 'checkbox' ? target.checked : target.value;
      var name = target.name;

      if (!name) {
        throw Error('Field must have a name attribute!');
      }

      setFormState(function (state) {
        var _extends2;

        return _extends({}, state, (_extends2 = {}, _extends2[name] = value, _extends2));
      });

      var omit = validationMessages[name],
          otherValidationMessages = _objectWithoutPropertiesLoose(validationMessages, [name].map(_toPropertyKey));

      setValidationMessages(otherValidationMessages);

      if (typeof _onChange === 'function') {
        var _extends3;

        _onChange(event, _extends({}, formState, (_extends3 = {}, _extends3[name] = value, _extends3)));
      }
    },
    isSubmitting: isSubmitting,
    setIsSubmitting: setIsSubmitting
  };
};

var _default = useForm;
exports["default"] = _default;